import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DisplayMode } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { Sgke131aResponseBasicInfo, Sgke131aResponseBikoran } from 'sg-api';

@Component({
  selector: 'app-sgke130d-bikoran',
  templateUrl: './sgke130d-bikoran.component.html',
  styleUrl: './sgke130d-bikoran.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke130dBikoranComponent implements OnInit, OnDestroy {
  /** モード区分 */
  @Input() mode: string;
  /** 基本情報 */
  @Input() basicInfo: Sgke131aResponseBasicInfo;
  /** 備考欄 */
  @Input() bikoran: Sgke131aResponseBikoran;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  /** 親フォーム情報 */
  private parentForm: UntypedFormGroup;

  /** モード区分_承認 */
  public MODE_APPROVE = DisplayMode.approve;

  /** 入金突合ステータス_未報告 */
  public RECONCILIATION_STATUSCODE_UNREPORTED = "0";
  /** 入金突合ステータス_報告済 */
  public RECONCILIATION_STATUSCODE_REPORTED = "1";
  /** 入金突合ステータス_承認済 */
  public RECONCILIATION_STATUSCODE_APPROVED = "2";

  /** 備考欄FormGroup */
  bikoranForm: UntypedFormGroup;

  /**
   * コンストラクタ
   * @param {FormGroupDirective} parent
   * @param {UntypedFormBuilder} fb
   * @memberof Sgke130dBikoranComponent
   */
  constructor(
    private parent: FormGroupDirective,
    private fb: UntypedFormBuilder,
  ) { }

  /**
   * 初期処理
   * 
   * @memberof Sgke130dBikoranComponent
   */
  ngOnInit(): void {
    // 親フォーム取得
    this.parentForm = this.parent.form;

    this.bikoranForm = this.fb.group({
      // 備考欄
      biko: this.fb.nonNullable.control({ value: this.bikoran.biko, disabled: this.isBikoranInvalid() }),
    });
    // 親コンポーネントのformに検索条件formを追加
    this.parentForm.addControl("bikoranForm", this.bikoranForm);
  }

  /**
   * コンポーネントが破棄される際に呼び出されるライフサイクルフック
   * リソースの解放や購読の解除
   * 
   * @memberof Sgke130dBikoranComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('reportInfo');
  }

  /**
   * 備考欄活性非活性判定
   *
   * @returns {boolean} true:非活性、false:活性
   * @memberof Sgke130dBikoranComponent
   */
  isBikoranInvalid(): boolean {
    if (this.mode == this.MODE_APPROVE) {
      // 承認画面の場合、非活性
      return true;
    }

    if (this.basicInfo.reconciliationStatuscode == this.RECONCILIATION_STATUSCODE_APPROVED ) {
      // 入金突合ステータスが承認済み場合、非活性
      return true;
    }

    return false;
  }

}
